export const COACHING_PANEL = 'activity-page.coaching-panel'

export function coachingPanelsFromPayload(payload) {
    try {
        return JSON.parse(payload).components
            .map((component) => JSON.parse(component.snapshot).memo)
            .filter((memo) => memo.name === COACHING_PANEL)
    } catch {
        return []
    }
}

export function revealCoachingPanelFailure(root, reload = () => window.location.reload()) {
    const skeletons = root?.querySelector('[data-nurse-performance-skeletons]')
    const fallback = root?.querySelector('[data-nurse-performance-load-error]')
    const retry = fallback?.querySelector('[data-nurse-performance-reload]')

    if (!fallback || !retry) {
        return false
    }

    skeletons?.remove()
    fallback.hidden = false
    fallback.setAttribute('role', 'status')
    fallback.setAttribute('aria-live', 'polite')
    fallback.setAttribute('aria-atomic', 'true')

    if (retry.dataset.nursePerformanceRetryBound !== 'true') {
        retry.dataset.nursePerformanceRetryBound = 'true'
        retry.addEventListener('click', () => {
            retry.disabled = true
            retry.setAttribute('aria-busy', 'true')
            retry.querySelector('[data-nurse-performance-retry-idle]')?.setAttribute('hidden', '')
            retry.querySelector('[data-nurse-performance-retry-busy]')?.removeAttribute('hidden')
            reload()
        }, {once: true})
    }

    return true
}

export function registerCoachingPanelFailureHandler(documentObject = document, windowObject = window) {
    documentObject.addEventListener('livewire:init', () => {
        windowObject.Livewire.hook('request', ({payload, fail}) => {
            fail(({status, preventDefault}) => {
                const panels = coachingPanelsFromPayload(payload)

                if (panels.length === 0 || status === 419) {
                    return
                }

                panels.forEach((memo) => {
                    const root = documentObject.querySelector(`[wire\\:id="${memo.id}"]`)
                    revealCoachingPanelFailure(root, () => windowObject.location.reload())
                })

                const error = new Error(`Coaching panel failed to load (HTTP ${status})`)
                console.error(error)
                windowObject.$sentry?.captureException(error)

                if (panels.length === JSON.parse(payload).components.length) {
                    preventDefault()
                }
            })
        })
    })
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    registerCoachingPanelFailureHandler()
}
